import SideMenu from '@/containers/side-menu/SideMenu.vue';
const RelateTariffSchedule = () => import('@/pages/relate-tariff-schedule/RelateTariffSchedule.vue');

export default {
  path: '/relate-tariff-schedule',
  name: 'RelateTariffSchedule',
  components: {
    mainContent: RelateTariffSchedule,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'relate-tariff-schedule',
    },
    breadcrumb: {
      title: 'Serviço tarifário',
      paths: [{ title: 'relacionar plano tarifário' }],
    },
  },
};
